<template>
  <a-layout>
    <a-layout-header class="admin-header">
      <div class="header-content">
        <div class="logo" @click="handleLogoClick"></div>
        <a-menu class="menu" v-model="current" theme="dark" mode="horizontal" :defaultSelectedKeys="[]" @click="handleMenuClick">
          <a-menu-item key="/">Home</a-menu-item>
          <a-menu-item key="/analysis">Analysis</a-menu-item>
          <a-menu-item key="/data">Data</a-menu-item>
          <a-menu-item key="/help">Help</a-menu-item>
          <a-menu-item key="/about">About</a-menu-item>
        </a-menu>
      </div>
    </a-layout-header>

    <a-layout-content style="background-color: #fff;padding-top: 66px;">
        <div class="content-content">
            <router-view />
        </div>
    </a-layout-content>

    <a-layout-footer style="text-align: center; height: 50px; padding: 16px 50px;">
        <span style="margin-right: 10px;">Copytight ©</span>
        <span style="margin-right: 10px;">2024, Dai’s Lab. Supported by <a href="https://hiplot.com.cn" target="_blank">Hiplot</a></span>
        <span>All Rights Reserved</span>
    </a-layout-footer>
    <cookie-consent />
  </a-layout>
</template>

<script>
import CookieConsent from '@/components/CookieConsent.vue'; // Import the new component
export default {
    name: 'CustomLayout',
    components: {
      CookieConsent, // Register the component
    },
    data() {
        return {
            current: [],
        };
    },
    watch: {
      $route() {
        this.current = [this.$route.path]
      }
    },
    created() {
      this.current = [this.$route.path]
    },
    methods: {
        handleLogoClick() {
            this.jumpToRoute('/')
        },
        handleMenuClick(e) {
            this.jumpToRoute(e.key)
        },
        jumpToRoute(path) {
            if (this.$route.path !== path) {
                this.$router.push(path);
            }
        }
    },
};
</script>

<style scoped>
.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1800px;
  margin: 0 auto;
  padding: 0 20px;
}

.content-content {
  background: #fff;
  padding: 24px;
  min-height: calc(100vh - 114px);
  max-width: 1800px;
  margin:0 auto;
}

.menu {
  font-size: 20px;
}

.logo {
    width: 50px;
    height: 50px;
    background: url("~@/assets/logo.png") no-repeat center center;
    background-size: cover;
    margin: 8px 28px 8px 0;
    float: left;
    cursor: pointer;
}
</style>